/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response for get reminder groups
 * @export
 * @interface ReminderGroupResponse
 */
export interface ReminderGroupResponse {
    /**
     * Unique identifier of the reminder group
     * @type {string}
     * @memberof ReminderGroupResponse
     */
    id?: string;
    /**
     * ID of the associated patient document
     * @type {number}
     * @memberof ReminderGroupResponse
     */
    patientDocumentId?: number | null;
    /**
     * ID of the associated fee invoice
     * @type {number}
     * @memberof ReminderGroupResponse
     */
    feeInvoiceId?: number | null;
    /**
     * Reminder level (1, 2, or 3)
     * @type {number}
     * @memberof ReminderGroupResponse
     */
    reminderLevel?: number;
    /**
     * The date and time of the reminder
     * @type {string}
     * @memberof ReminderGroupResponse
     */
    reminderDateTime?: string;
    /**
     * false once any invoice in the group is fully paid
     * @type {boolean}
     * @memberof ReminderGroupResponse
     */
    allOutstanding?: boolean;
}

/**
 * Check if a given object implements the ReminderGroupResponse interface.
 */
export function instanceOfReminderGroupResponse(value: object): value is ReminderGroupResponse {
    return true;
}

export function ReminderGroupResponseFromJSON(json: any): ReminderGroupResponse {
    return ReminderGroupResponseFromJSONTyped(json, false);
}

export function ReminderGroupResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReminderGroupResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'patientDocumentId': json['patientDocumentId'] == null ? undefined : json['patientDocumentId'],
        'feeInvoiceId': json['feeInvoiceId'] == null ? undefined : json['feeInvoiceId'],
        'reminderLevel': json['reminderLevel'] == null ? undefined : json['reminderLevel'],
        'reminderDateTime': json['reminderDateTime'] == null ? undefined : json['reminderDateTime'],
        'allOutstanding': json['allOutstanding'] == null ? undefined : json['allOutstanding'],
    };
}

export function ReminderGroupResponseToJSON(json: any): ReminderGroupResponse {
    return ReminderGroupResponseToJSONTyped(json, false);
}

export function ReminderGroupResponseToJSONTyped(value?: ReminderGroupResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'patientDocumentId': value['patientDocumentId'],
        'feeInvoiceId': value['feeInvoiceId'],
        'reminderLevel': value['reminderLevel'],
        'reminderDateTime': value['reminderDateTime'],
        'allOutstanding': value['allOutstanding'],
    };
}

